import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { getOnboardingTemplates } from 'src/selectors/onboarding'
import { GSIcon } from 'src/components/shared/GSIcon'
import { LimitedStringChip } from 'src/components/shared/LimitedStringChip'
import { TableSelect } from './TableSelect'

interface Props {
  selectedTemplateIds: Array<string>
  setSelectedTemplateIds(templateIds: Array<string>): void
  triggerDataTestId?: string
  clearAllDataTestId?: string
  searchInputDataTestId?: string
}

const TableAssignedTemplateSelectComponent = ({
  selectedTemplateIds,
  setSelectedTemplateIds,
  triggerDataTestId,
  clearAllDataTestId,
  searchInputDataTestId,
}: Props) => {
  const onboardingTemplates = useSelector(getOnboardingTemplates)

  return (
    <TableSelect<string>
      title="Assigned Template"
      selectedValues={selectedTemplateIds}
      icon={<GSIcon iconName="gs_icon_clipboard" width={20} height={20} />}
      options={onboardingTemplates.map((item) => ({
        value: item.id,
        label: item.name,
        component: <LimitedStringChip text={item.name} />,
      }))}
      searchable
      searchPlaceholder="Search"
      menuWidth={258}
      onSelect={setSelectedTemplateIds}
      triggerDataTestId={triggerDataTestId}
      clearAllDataTestId={clearAllDataTestId}
      searchInputDataTestId={searchInputDataTestId}
    />
  )
}

export const TableAssignedTemplateSelect = memo(TableAssignedTemplateSelectComponent)
